// ===============================
// pages/AdminProducts.jsx
// FULL UPDATED ADMIN PANEL
// ===============================

import React, {
  useEffect,
  useState,
} from "react";

import axios from "axios";

import "./AdminProducts.css";

const AdminProducts = () => {

  // ===============================
  // STATES
  // ===============================
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [products, setProducts] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [search, setSearch] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const [itemsPerPage, setItemsPerPage] =
    useState(10);

  const [totalPages, setTotalPages] =
    useState(1);

  const [totalProducts, setTotalProducts] =
    useState(0);

  const [editId, setEditId] =
    useState("");

  const [showAddModal, setShowAddModal] =
    useState(false);

  // ===============================
  // FORM DATA
  // ===============================

  const [formData, setFormData] =
    useState({

      name: "",

      category: "",

      brand: "",

      price: "",

      discountPrice: "",

      stock: "",

      warranty: "",

      promoCode: "",

      offerText: "",

      image: "",

      images: "",

      description: "",

    });

  // ===============================
  // FETCH PRODUCTS
  // ===============================

  useEffect(() => {

    fetchProducts();

  }, [
    currentPage,
    itemsPerPage,
    search,
  ]);

  const fetchProducts = async () => {

    try {

      setLoading(true);

      const res = await axios.get(

        `${BASE_URL}/api/products?page=${currentPage}&limit=${itemsPerPage}&search=${search}`

      );

      setProducts(
        res.data.products || []
      );

      setTotalPages(
        res.data.totalPages || 1
      );

      setTotalProducts(
        res.data.totalProducts || 0
      );

      setLoading(false);

    } catch (error) {

      console.log(error);

      setLoading(false);

    }

  };

  // ===============================
  // HANDLE CHANGE
  // ===============================

  const handleChange = (e) => {

    setFormData({

      ...formData,

      [e.target.name]:
        e.target.value,

    });

  };

  // ===============================
  // RESET FORM
  // ===============================

  const resetForm = () => {

    setEditId("");

    setShowAddModal(false);

    setFormData({

      name: "",

      category: "",

      brand: "",

      price: "",

      discountPrice: "",

      stock: "",

      warranty: "",

      promoCode: "",

      offerText: "",

      image: "",

      images: "",

      description: "",

    });

  };

  // ===============================
  // SUBMIT
  // ===============================

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const imagesArray =
        formData.images
          .split(",")

          .map((img) =>
            img.trim()
          )

          .filter(Boolean);

      const productData = {

        ...formData,

        price:
          Number(formData.price),

        discountPrice:
          Number(
            formData.discountPrice
          ),

        stock:
          Number(formData.stock),

        images:
          imagesArray,

      };

      // UPDATE

      if (
        editId !== null &&
        editId !== ""
      ) {

        await axios.put(

          `${BASE_URL}/api/products/${editId}`,

          productData

        );

        alert(
          "Product Updated"
        );

      }

      // CREATE

      else {

        await axios.post(

          `${BASE_URL}/api/products`,

          productData

        );

        alert(
          "Product Added"
        );

      }

      fetchProducts();

      resetForm();

      setLoading(false);

    } catch (error) {

      console.log(error);

      setLoading(false);

    }

  };

  // ===============================
  // DELETE
  // ===============================

  const deleteProduct = async (id) => {

    const confirmDelete =
      window.confirm(
        "Delete this product?"
      );

    if (!confirmDelete) return;

    try {

      await axios.delete(

        `${BASE_URL}/api/products/${id}`

      );

      fetchProducts();

    } catch (error) {

      console.log(error);

    }

  };

  // ===============================
  // EDIT
  // ===============================

  const editProduct = (product) => {

    setEditId(product._id);

    setFormData({

      name:
        product.name || "",

      category:
        product.category || "",

      brand:
        product.brand || "",

      price:
        product.price || "",

      discountPrice:
        product.discountPrice || "",

      stock:
        product.stock || "",

      warranty:
        product.warranty || "",

      promoCode:
        product.promoCode || "",

      offerText:
        product.offerText || "",

      image:
        product.image || "",

      images:
        product.images
          ?.join(", ") || "",

      description:
        product.description || "",

    });

  };

  return (
    <div className="admin-products-page">

      {/* HEADER */}

      <div className="admin-header">

        <div className="container">

          <h1>
            Product Management
          </h1>

          <p>

            Total Products:
            {" "}
            {totalProducts}

          </p>

        </div>

      </div>

      <div className="container">

        {/* TOP BAR */}

        <div className="table-header">

          <h2>
            All Products
          </h2>

          <div className="table-header-right">

            {/* SEARCH */}

            <div className="admin-search">

              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => {

                  setSearch(
                    e.target.value
                  );

                  setCurrentPage(1);

                }}
              />

              <button type="button">

                <i className="fa-solid fa-magnifying-glass"></i>

              </button>

            </div>

            {/* ITEMS */}

            <select
              className="items-select"
              value={itemsPerPage}
              onChange={(e) => {

                setItemsPerPage(
                  Number(
                    e.target.value
                  )
                );

                setCurrentPage(1);

              }}
            >

              <option value={10}>
                Show 10
              </option>

              <option value={20}>
                Show 20
              </option>

              <option value={50}>
                Show 50
              </option>

              <option value={100}>
                Show 100
              </option>

            </select>

            {/* ADD */}

            <button
              className="add-product-open-btn"
              onClick={() =>
                setShowAddModal(true)
              }
            >

              <i className="fa-solid fa-plus"></i>

              Add Product

            </button>

          </div>

        </div>

        {/* TABLE */}

        <div className="products-table-wrapper">

          <table className="products-table">

            <thead>

              <tr>

                <th>Image</th>

                <th>Name</th>

                <th>Category</th>

                <th>Price</th>

                <th>Discount</th>

                <th>Stock</th>

                <th>Promo</th>

                <th>Actions</th>

              </tr>

            </thead>

            <tbody>

              {loading ? (

                <tr>

                  <td
                    colSpan="8"
                    className="loading-cell"
                  >

                    Loading Products...

                  </td>

                </tr>

              ) : (

                products.map((item) => (

                  <tr key={item._id}>

                    <td>

                      <img
                        src={item.image}
                        alt={item.name}
                        className="table-product-img"
                      />

                    </td>

                    <td>

                      <div className="table-product-name">

                        <h4>
                          {item.name}
                        </h4>

                        <p>
                          {item.brand}
                        </p>

                      </div>

                    </td>

                    <td>

                      <span className="table-category">

                        {item.category}

                      </span>

                    </td>

                    <td>

                      ₹{item.price}

                    </td>

                    <td>

                      {item.discountPrice ? (

                        <div className="discount-box">

                          ₹
                          {item.discountPrice}

                        </div>

                      ) : (

                        "-"

                      )}

                    </td>

                    <td>

                      <span
                        className={
                          item.stock > 0
                            ? "stock-in"
                            : "stock-out"
                        }
                      >

                        {item.stock}

                      </span>

                    </td>

                    <td>

                      {item.promoCode || "-"}

                    </td>

                    <td>

                      <div className="table-actions">

                        <button
                          type="button"
                          className="edit-btn"
                          onClick={() =>
                            editProduct(item)
                          }
                        >

                          <i className="fa-solid fa-pen"></i>

                        </button>

                        <button
                          type="button"
                          className="delete-btn"
                          onClick={() =>
                            deleteProduct(
                              item._id
                            )
                          }
                        >

                          <i className="fa-solid fa-trash"></i>

                        </button>

                      </div>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}

        <div className="pagination">

          <button
            disabled={currentPage === 1}
            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }
          >
            Prev
          </button>

          {[...Array(totalPages)].map(
            (_, index) => (

              <button
                key={index}
                className={
                  currentPage ===
                  index + 1
                    ? "active-page"
                    : ""
                }
                onClick={() =>
                  setCurrentPage(
                    index + 1
                  )
                }
              >

                {index + 1}

              </button>

            )
          )}

          <button
            disabled={
              currentPage ===
              totalPages
            }
            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }
          >
            Next
          </button>

        </div>

      </div>

      {/* ===============================
          ADD PRODUCT MODAL
      =============================== */}

      {showAddModal && (

        <div className="admin-modal">

          <div className="admin-modal-content">

            <div className="modal-header">

              <h2>
                Add Product
              </h2>

              <button
                className="close-modal"
                onClick={resetForm}
              >
                ×
              </button>

            </div>

            <form
              onSubmit={handleSubmit}
            >

              <div className="form-grid">

                <input
                  type="text"
                  name="name"
                  placeholder="Product Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <input
                  type="text"
                  name="category"
                  placeholder="Category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                />

                <input
                  type="text"
                  name="brand"
                  placeholder="Brand"
                  value={formData.brand}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="price"
                  placeholder="Price"
                  value={formData.price}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="discountPrice"
                  placeholder="Discount Price"
                  value={formData.discountPrice}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="stock"
                  placeholder="Stock"
                  value={formData.stock}
                  onChange={handleChange}
                />

              </div>

              <textarea
                name="description"
                rows="5"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
              />

              <button
                type="submit"
                className="update-modal-btn"
              >

                Add Product

              </button>

            </form>

          </div>

        </div>

      )}

      {/* ===============================
          EDIT PRODUCT MODAL
      =============================== */}

      {editId && (

        <div className="admin-modal">

          <div className="admin-modal-content">

            <div className="modal-header">

              <h2>
                Edit Product
              </h2>

              <button
                className="close-modal"
                onClick={resetForm}
              >
                ×
              </button>

            </div>

            <form
              onSubmit={handleSubmit}
            >

              <div className="form-grid">

                <input
                  type="text"
                  name="name"
                  placeholder="Product Name"
                  value={formData.name}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="category"
                  placeholder="Category"
                  value={formData.category}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="brand"
                  placeholder="Brand"
                  value={formData.brand}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="price"
                  placeholder="Price"
                  value={formData.price}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="discountPrice"
                  placeholder="Discount Price"
                  value={formData.discountPrice}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="stock"
                  placeholder="Stock"
                  value={formData.stock}
                  onChange={handleChange}
                />

              </div>

              <textarea
                name="description"
                rows="5"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
              />

              <button
                type="submit"
                className="update-modal-btn"
              >

                Update Product

              </button>

            </form>

          </div>

        </div>

      )}

    </div>
  );
};

export default AdminProducts;